import { useState } from 'react';
import { usePanel } from '../App.jsx';
import { nombreClinica } from '../clinicas';
import { infoOrg } from '../org';
import { horaMadrid, hoyISO, useColeccion, useReloj } from '../dia/comun';
import { Llamadas, Notas } from '../dia/Llamadas.jsx';
import { Caja, Registros } from '../dia/Caja.jsx';

// Cuántas cosas necesitan que alguien haga algo, por pestaña (para los números rojos)
export function useAvisosDia(clinicas, uid) {
  useReloj();
  const llam = useColeccion('llamadas', clinicas, [['hecha', '==', false]]) || [];
  const notas = useColeccion('notasTurno', clinicas, [['dia', '>=', hoyISO(new Date(Date.now() - 7 * 864e5))]]) || [];
  const regs = useColeccion('registros', clinicas, [['dia', '==', hoyISO()]]) || [];
  const notasNuevas = notas.filter((n) => !n.hecha && !(n.vistoPor || []).includes(uid)).length;
  const h = horaMadrid();
  // El aviso de la nevera solo si la clínica lo activa (Mi clínica → Organización)
  const regFaltan = !infoOrg().controlNevera ? 0 : clinicas.reduce((n, c) => {
    const r = regs.find((x) => x.clinica === c) || {};
    return n + (h >= 12 && !r.neveraM ? 1 : 0) + (h >= 19 && !r.neveraT ? 1 : 0);
  }, 0);
  return { llamadas: llam.length, notas: notasNuevas, registros: regFaltan, total: llam.length + notasNuevas + regFaltan };
}

const PESTANAS = [
  ['llamadas', 'Llamadas'],
  ['notas', 'Notas de turno'],
  ['caja', 'Caja'],
  ['registros', 'Registros'],
];

export default function DiaADia() {
  const { user, clinica, clinicasActivas, esAdmin, esEquipo } = usePanel();
  const [tab, setTab] = useState('llamadas');
  const yo = user?.displayName || user?.email || '';
  const av = useAvisosDia(clinicasActivas, user?.uid);
  return (
    <section>
      <div className="cabecera"><div><h1>Día a día</h1><p className="subtitulo">{nombreClinica(clinica)} · llamadas, notas del turno{esEquipo ? '' : ', caja'} y registros</p></div></div>
      <div className="filtros pestanas">
        {PESTANAS.filter(([k]) => !(esEquipo && k === 'caja')).map(([k, t]) => (
          <button key={k} className={tab === k ? 'on' : ''} onClick={() => setTab(k)}>{t}{av[k] > 0 && <span className="pend-badge">{av[k]}</span>}</button>
        ))}
      </div>
      {tab === 'llamadas' && <Llamadas clinicas={clinicasActivas} yo={yo} uid={user?.uid} />}
      {tab === 'notas' && <Notas clinicas={clinicasActivas} yo={yo} uid={user?.uid} />}
      {tab === 'caja' && !esEquipo && <Caja clinicas={clinicasActivas} yo={yo} esAdmin={esAdmin} />}
      {tab === 'registros' && <Registros clinicas={clinicasActivas} yo={yo} />}
    </section>
  );
}
